import { connect } from 'react-redux'
import {
    resetCollaborativeIndexationCreationInvalidField,
    updateCollaborativeIndexationFieldValue,
} from '../../../../../../redux/collaborativeIndexations/actions'
import {
    getCollaborativeIndexationCreationFields,
    isCollaborativeIndexationCreationInvalidField
} from '../../../../../../redux/collaborativeIndexations/selectors'
import Year from './Year.jsx'

const mapDispatchToProps = (dispatch, getState) => ({
    updateFieldValue: (field, value) => dispatch(updateCollaborativeIndexationFieldValue(field, value)),
    resetInvalidField: field => dispatch(resetCollaborativeIndexationCreationInvalidField(field))
})

const mapStateToProps = state => ({
    fields: getCollaborativeIndexationCreationFields(state),
    isInvalidField: field => isCollaborativeIndexationCreationInvalidField(state, field),
})

export const YearContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Year)
